import { useQuery } from '@apollo/client';
import { READ_SALES_ORDER_PMC_PROMOTION } from 'graphql/queries/readSalesOrderPmcPromotion';
import {
  CustomerPmcPromotion,
  Maybe,
  PaymentType,
  Query,
  QueryReadSalesOrderPmcPromotionArgs,
} from 'types/generatedSchemaTypes';

type UsePmcPromotionResult = {
  promotion: Maybe<CustomerPmcPromotion> | undefined;
  loading: boolean;
};

const usePmcPromotion = (
  pmcId: string | undefined,
  paymentMethod: PaymentType = 'CREDIT_CARD'
): UsePmcPromotionResult => {
  const { data, loading } = useQuery<
    Query,
    QueryReadSalesOrderPmcPromotionArgs
  >(READ_SALES_ORDER_PMC_PROMOTION, {
    variables: {
      pmcId: pmcId ?? '',
      paymentMethod,
    },
    skip: !pmcId,
    fetchPolicy: 'cache-and-network',
  });

  return { promotion: data?.readSalesOrderPmcPromotion, loading };
};

export default usePmcPromotion;
